// extracted by mini-css-extract-plugin
export default {"compWrapper":"UploadVideoComp_compWrapper__LbPII","compRow":"UploadVideoComp_compRow__UlSZi","colLeft":"UploadVideoComp_colLeft__6YaWL","colRight":"UploadVideoComp_colRight__C-PvD"};